import { TFeed } from 'types/TFeeds';

type TParams = {
  l1CategoryId: number;
  feed: TFeed;
  feedPostcode?: string;
  page?: number;
};

/**
 * Generate query params to fetch feed items
 */
export default ({ l1CategoryId, feed, feedPostcode, page = 0 }: TParams) => ({
  feedType: feed.feedType,
  categoryId: l1CategoryId,

  postcode: feed.locationRequired ? feedPostcode : undefined,
  page,
});
